<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/R3IlOy/tc-custom/9780813195995.jpg?1728327093104" alt="This image is the cover for the book Marlene"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marlene
      </h1>
      <p class="bookDescription body article font2">
        <b>A fascinating self-portrait of one of the greatest entertainers of Hollywood’s golden age </b><b><br/></b><br/>Film star. Cabaret sensation. Recording artist. Writer. Marlene Dietrich was nothing short of enchanting—and remains so as she chronicles her fabulous rise to stardom in <i>Marlene</i>. From her early career in Germany as a chorus girl to her breakout role as Lola in <i>The Blue Angel</i> to her courageous wartime tours, Dietrich recounts a life that captivates on the page just as she smoldered on the screen. She writes passionately of her friends—including Charlie Chaplin, Orson Welles, and Edith Piaf, among many others—and she shares memories of what she calls her greatest accomplishment: entertaining the Allied troops during World War II. A sustained expression of her bold, sophisticated style, <i>Marlene</i> reminds us why Dietrich remains an international icon and a true Hollywood legend. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marlene Dietrich
      </h2>
      
      <p class="authorDescription body article">Marlene Dietrich (1901&ndash;1992) was a film actress and accomplished singer, widely considered among the greatest female stars of all time, and ranked number nine on the American Film Institute&rsquo;s list of the fifty greatest American screen legends. Born in Germany in 1901, Dietrich was a classically trained violinist, but she shifted her focus to acting and singing when she injured her wrist in 1921. Her breakthrough film role in Josef von Sternberg&rsquo;s <i>The Blue Angel</i> led to her contract with Paramount Studios and a string of Hollywood hits, including <i>Shanghai Express</i>. She became an American citizen and strongly supported the Allied effort during World War II; in 1947, she was awarded the Medal of Freedom for her contributions. During Dietrich&rsquo;s later career, she performed almost exclusively as a cabaret artist, entertaining audiences worldwide. She died in Paris in 1992.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2be065f5